import React from 'react';
import ReactDOM from 'react-dom/client'; // Import createRoot from react-dom/client

import { Provider } from 'mobx-react';

import App from './App';
import './index.css';

import FreespaceClient from './services/FreespaceClient';
import FreespaceRealtime from './services/FreespaceRealtime';
import SignageState from './stores/ui/SignageState';
import './utils/StateLogger'; // Initialize state logger
import './utils/ConsoleHelper'; // Initialize console helper

const authKey = localStorage.getItem('spaceio-key');
const signageId = JSON.parse(localStorage.getItem('freespace-screen')).id;
const { locationId } = JSON.parse(localStorage.getItem('freespace-screen'));

const base = 'https://prodws.afreespace.com';
const analyticsApi = 'https://analytics.afreespace.com';
const electron = navigator.userAgent.replace('Electron', '') !== navigator.userAgent;
let heartbeatBase = (window.location.hostname === 'local.afreespace.com') || electron ? 'https://connect.afreespace.com' : null;
const signageCmsBase = 'https://signagecms.qa.afreespace.com';
const bearerToken = "eyJhbGciOiJSUzI1NiJ9.eyJ1dHAiOiJVIiwidHRwIjoiQUNDIiwic3ViIjoiMzE4MDUwIiwiYXVkIjoiaHR0cHM6Ly9iZXRhLWFkbWluLmFmcmVlc3BhY2UuY29tLz9yZWRpcmVjdF90bz1odHRwcyUzQSUyRiUyRmJldGEtYWRtaW4uYWZyZWVzcGFjZS5jb20lMkYxMzU4JTJGZXN0YXRlLWxpc3QuaHRtbCIsImV4cCI6MTc1Njc2NjQ2NSwiYWlkIjoxMiwiaWF0IjoxNzU2MTE4NDY1fQ.ax0E8L9IR_eJLbfTpd1PbukRQ5Z_GXo_swFfORKVkpkdvo6JNGh13_tpNHhdT4_n94FazMkMksDlWkL8yZ-2MnIy4csegORf-42jai8gUwP0Lc1IM_MzimzWihF6GyiLLzcop7043pflsdkCXlS306-Wr0CrL2dMrkQEFKi0gLq4_ZrzUgyki5QgHWLPsmvcaQh-9tEunY5Dk_QEPJq9rl4_DOCDJzEk--_vRR3SiPvFZobHEzh1d0Tv95A7al8a1PRuWmBGUcCYe3iNd_qHuC9cN7BbjyRma7ZpObJPr1wTWeMngHu-Cbei9_DsTS7vbZY7_bE4Z1kJGhQaCYAv_Q";
const client = new FreespaceClient(authKey, base, analyticsApi, heartbeatBase, signageCmsBase, bearerToken);
const realtime = new FreespaceRealtime(authKey, base);

const signageState = new SignageState(client, realtime);
signageState.showSignage(signageId).then(() => {});

// Create root using createRoot
const root = ReactDOM.createRoot(document.getElementById('root'));

// Use root.render instead of ReactDOM.render
root.render(
  <Provider signageState={signageState}>
    <App />
  </Provider>
);
